import { IExternalProjectData } from '@models/Consumers';
import { EnumExternalProject } from '@models/Common';

export class ExternalDataUtils {

    /**
     * Converte a string JSON de `ProjectExternalData` em objeto. Devolve null se vazia ou inválida.
     */
    static Parse(raw: string): IExternalProjectData {

        if (!raw) return null;

        try {
            const parsed = JSON.parse(raw);

            return parsed && typeof parsed === 'object' ? parsed : null;
        } catch {
            return null;
        }
    }

    /**
     * Indica se o campo foi obtido da AMA / autenticação.gov (`idProject` raiz do pedido = AMA e valor preenchido em `data`)
     * @param idProject IdProject raiz do pedido/consumidor
     * @param path caminho do campo, ex.: 'Name' ou 'Location.Address'
     */
    static IsFromAma(idProject: number, data: IExternalProjectData, path: string): boolean {

        if (Number(idProject) !== EnumExternalProject.AMA) return false;

        const value = path.split('.').reduce((acc: any, key) => acc?.[key], data);

        return value !== null && value !== undefined && value !== '';
    }

    /**
     * Filtra os consentimentos pelos projetos configurados em `Pages.Consumer.ConsentIdProjects` (vazio = todos)
     */
    static FilterConsents(list: any[], idProjects: number[]): any[] {

        list = list || [];

        if (!idProjects?.length) return list;

        return list.filter(it => idProjects.some(id => Number(id) === Number(it?.Project?.Id)));
    }
}
